import { all } from 'redux-saga/effects';

import salaryMonthWiseWatcher from './salary-monthwise-saga';

export default function* rootSaga(action) {
	yield all([salaryMonthWiseWatcher(action)]);
}
